module.exports = {
    expired_1: "ลิงก์หมดอายุ",
    limit_time: "ข้อเสนอช่วงเวลาจำกัดสำหรับ ",
    participate: "เข้าร่วมกิจกรรมรีวิวตอนนี้เพื่อรับรางวัลพิเศษของคุณ!",
    exclusive: "พิเศษ",
    reward: "รางวัล",
    token: "โทเค็น",
    vip: "วัน VIP",
    after_completing: "หลังจาก完成รีวิวและการยืนยันภาพหน้าจอแล้ว คุณจะได้รับ",
    step_1: "<strong style='color: #000000'>คลิกปุ่มด้านล่าง</strong> เพื่อไปที่ร้านค้าแอปและ <strong style='color: #000000'>เขียนรีวิว 5 ดาว</strong>",
    step_2: "หลังจากเขียนรีวิวแล้ว กรุณา <strong style='color: #000000'>ถ่ายภาพหน้าจอ</strong> เนื้อหารีวิวของคุณ",
    step_3: "<strong style='color: #000000'>อัปโหลดภาพหน้าจอ</strong> ด้านล่างและส่ง ID ในแอปของคุณเพื่อรับรางวัล",
    click_to: "1. คลิกเพื่อไปที่ ",
    upload: "2. อัปโหลดภาพหน้าจอรีวิว",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "ไปที่ ",
    example: "ตัวอย่างภาพหน้าจอ",
    upload_screenshot: "อัปโหลดภาพหน้าจอ",
    claim: "รับรางวัล",
    verification_inprogress: "ขอบคุณสำหรับการอัปโหลด ภาพหน้าจอของคุณกำลังถูกตรวจสอบอย่างเร็วที่สุด กรุณารอสักครู่",
    verification_success: "ขอแสดงความยินดี! <br/><br/> คุณได้รับรางวัลสำเร็จแล้ว รางวัลจะถูกโอนเข้าบัญชีของคุณ <strong>ภายใน 24 ชั่วโมง</strong> กรุณาติดตาม <br/><br/> หากมีข้อสงสัย กรุณาติดต่อฝ่ายบริการลูกค้า",
    verification_failed: "ภาพหน้าจอรีวิวต้องเป็นไปตามข้อกำหนดดังนี้: <br/><br/> <div style='margin-left: 6px'> 1.คะแนนรีวิวต้อง 5 ดาวและเนื้อหาต้องเป็นเชิงบวก <br/><br/> 2.ต้องรีวิวใน <strong> Apple App Store หรือ Google Play Store </strong> <br/><br/> 3.ภาพหน้าจอจะต้องแสดงเนื้อหาของรีวิวทั้งหมด รวมถึง <strong> ภาพโปรไฟล์, ชื่อผู้ใช้ และข้อความรีวิว </strong> <strong></div>",
    reupload: "อัปโหลดใหม่",
}